import Office   from "./Office";
import OfficeId from "./OfficeId";

class Offices {
  constructor(private readonly _list: Office[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList() {
    return this._list;
  }

  public findBy(officeId: OfficeId): Office {
    const office = this._list.find(office => office.id.value === officeId.value);
    return office ? office : new Office();
  }
}

export default Offices;
